class VariantSelectorMini extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const firstAvailableButton = Array.from(this.querySelectorAll('.variant-btn')).find(button => !button.disabled);
    
    if (firstAvailableButton) {
      this.selectVariant(firstAvailableButton);
    }

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-action="select-variant"]');
      if (button) {
        this.selectVariant(button);
      }
    });
  }

  selectVariant(button) {
    const variantButtons = this.querySelectorAll('.variant-btn');
    
    variantButtons.forEach(btn => btn.classList.remove('active'));
    
    button.classList.add('active');
    
    const variantId = button.dataset.variantId;
    const form = this.closest('form');
    const variantInput = form.querySelector('.variant-id-input');
    
    variantInput.value = variantId;
    variantInput.disabled = false;
    
    const addToCartButton = form.querySelector('[data-add-to-cart]');
    if (addToCartButton) {
      addToCartButton.disabled = button.disabled;
    }

    this.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: { variantId }
    }));
  }
}

customElements.define('variant-selector-mini', VariantSelectorMini); 